import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useBoundary');

    return {
        CONNECTION_ERROR: t('connectionError'),
        SAVE_FAILED: t('saveFailed')
    };
};

export default useTranslation;
